import request from '@/service/request'

// 获取学区列表
const getSysUserLockRecordList = (params) => {
  return request.post('/app/sysUserLockRecord/page', params)
}
export {
  getSysUserLockRecordList
}
